// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'scale-unequal';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 3.567V16.97m-7.969-4.347 2.536-5.409 2.535 5.409' />
    <path d='M3.567 15.157a2.474 2.474 0 0 0 2.535-2.535h-5.07a2.475 2.475 0 0 0 2.535 2.535zm13.402-6.882-2.536-5.457-2.535 5.457m2.535 2.536a2.475 2.475 0 0 1-2.535-2.536h5.07a2.477 2.477 0 0 1-2.535 2.536zM2.079 7.816l13.12-5.353M5.74 16.969h6.52-5.071' />
  </g>
);

export const viewBox = '0 0 18 18';
